<script setup>
import { computed } from 'vue';

import ListAttribute from 'dashboard/components-next/CustomAttributes/ListAttribute.vue';
import CheckboxAttribute from 'dashboard/components-next/CustomAttributes/CheckboxAttribute.vue';
import MultipleChoiceAttribute from 'dashboard/components-next/CustomAttributes/MultipleChoiceAttribute.vue';
import DateAttribute from 'dashboard/components-next/CustomAttributes/DateAttribute.vue';
import OtherAttribute from 'dashboard/components-next/CustomAttributes/OtherAttribute.vue';

const props = defineProps({
  attribute: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['update']);

const handleUpdate = value =>
  emit('update', props.attribute.attributeKey, value);

const componentMap = {
  list: ListAttribute,
  checkbox: CheckboxAttribute,
  multiple_choice: MultipleChoiceAttribute,
  date: DateAttribute,
  default: OtherAttribute,
};

const CurrentAttributeComponent = computed(() => {
  return (
    componentMap[props.attribute.attributeDisplayType] || componentMap.default
  );
});
</script>

<template>
  <component
    :is="CurrentAttributeComponent"
    :attribute="attribute"
    @update="handleUpdate"
  />
</template>
